import { render } from "./portal_events.html?vue&type=template&id=d521e318&external"
import script from "./portal_events.js?vue&type=script&lang=js&external"
export * from "./portal_events.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__